import { useState, useEffect } from 'react'
import { TableBox } from "@lk-gtcom/ecomlab-components"
import { CardDynamic } from '../../components/CardsComponents/CardDynamic/CardDynamic'
import { OlegHttps, OlegHttp } from '../../fetchUrls'
import customHeaders, { getSpace } from '../../common/headers';
import useGeneralStore from '../../store/general';
import { msToLocalDate } from '../../common/constant';
import "./ProductCardExtended_Stocks.scss"

const ProductCardExtended_Stocks = ({
    tableData,
    tableCallback,
    checkFbs,
    nmid,
    apiId,
    date,
    paginatorRef
}) => {
    const [productMetrics, setProductMetrics] = useState([]);
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }

    const fetchProductCardGeneral = (abortController = new AbortController()) => {
        const api_id = `?api_id=${apiId}`
        const offer_id = `&offer_id=${nmid}`
        const fbs = `&fbs=${checkFbs}`

        let url = `${OlegHttps}/api/v1/analysis/product/card/sales${api_id + offer_id + fbs}`;

        const [date_from, date_to] = date;

        const body = JSON.stringify({
            date_from: msToLocalDate(date_from),
            date_to: msToLocalDate(date_to),
            limit: paginatorRef.current?.limit || 10,
            page: paginatorRef.current?.page || 1,
        });

        fetch(url, {
            body,
            method: 'POST',
            headers,
            signal: abortController.signal,
        })
            .then(async (res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    const err = await res.json();
                    throw new Error(JSON.stringify(err));
                }
            })
            .then((json) => {
                setProductMetrics(json);
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                if (abortController.signal.aborted) return;
            });
    };

    useEffect(() => {
        fetchProductCardGeneral()
    }, []);

    return (
        <section className='orders-and-sales-inside-content'>
            <div className='card-group'>
                {productMetrics?.length > 0
                    ? productMetrics?.map((data, i) => (
                        <CardDynamic key={JSON.stringify(data)} {...data} />
                    ))
                    : [...Array(5)]?.map((e, i) => (
                        <CardDynamic key={i} title={''} dynamic={''} value={''} />
                    ))}
            </div>

            <TableBox
                {...tableData}
                sortingFunc={tableCallback}
                paginator={true}
                ref={paginatorRef}
                fetchCallback={tableCallback}
            />
        </section>
    )
}

export { ProductCardExtended_Stocks }